<footer class="footer">
  <div class="container-fluid footer__container">
    <p class="footer__text">
      © <a href="/">Analytics</a> 2021</p>
    <p class="footer__copy">Разработка приложения: <a href="https://vk.com/vakil.gayfullin" target="_blank">Вакиль Гайфуллин</a></p>
  </div>
</footer>
